<template>
  <div class="user-filter-form custom-wrapper">
    <div class="filter-wrapper">
      <el-form
        label-position="right"
        label-width="80px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item label="商户 ID" prop="userid">
          <el-input
            v-model="filterForm.userid"
            placeholder="请输入商户 ID"
            @keyup.enter.native="onFilterSubmit">
          </el-input>
        </el-form-item>
        <el-form-item label="商户名称" prop="username">
          <el-input
            v-model="filterForm.username"
            placeholder="请输入商户名称"
            @keyup.enter.native="onFilterSubmit">
          </el-input>
        </el-form-item>
        <el-form-item
          label="代理商"
          v-if="hasRes('agent_index')" >
          <el-select
            filterable
            default-first-option
            style="width: 100%;"
            v-model="filterForm.agentid" >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="agent in agentList"
              :key="agent.agentid"
              :label="`${agent.agentname}（${agent.nickname}）`"
              :value="agent.agentid">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="resetFilters">重置</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  nam: 'UserFilterForm',
  data () {
    return {
      filterForm: {
        userid: '',
        username: '',
        agentid: ''
      }
    }
  },
  computed: {
    ...mapState('agent', [
      'agentList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapActions('agent', [
      'getAgents'
    ]),

    onFilterSubmit () {
      this.setPage(1)
      this.setFilters(this.filterForm)

      this.$emit('filter')
    },
    resetFilters () {
      this.$refs['filterForm'].resetFields()

      this.filterForm.agentid = ''
    },
    async getSelectDatas () {
      if (this.hasRes('agent_index')) {
        try {
          await this.getAgents({
            page: 1,
            pageSize: 9999
          })
        } catch (err) {
          console.log(err)
        }
      }
    }
  },
  mounted () {
    this.getSelectDatas()
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

</style>



// WEBPACK FOOTER //
// src/components/user/UserFilterForm.vue